import React from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="py-20 bg-white px-6" data-id="element-182">
      <div className="max-w-3xl mx-auto" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg md:prose-xl mx-auto text-brand-navy/90" data-id="element-184">
          <p className="mb-6 leading-relaxed" data-id="element-185">
            Estás en el pasillo 4 del supermercado. O quizás en medio de una
            cena familiar. De repente, sucede.
          </p>
          <p className="font-serif italic text-2xl md:text-3xl text-brand-navy mb-6 font-medium" data-id="element-186">
            El grito.
          </p>
          <p className="mb-6 leading-relaxed" data-id="element-187">
            Ese grito que no es de un niño "malcriado", sino de un niño cuyo
            mundo se está desmoronando. Sientes las miradas. Esos ojos extraños
            que te juzgan desde lejos, susurrando que "deberías tener más
            control".
          </p>
          <p className="mb-6 leading-relaxed" data-id="element-188">
            Sientes cómo el calor sube por tu cuello. Tu corazón late rápido.
            Por un segundo, tú también quieres gritar. Quieres salir corriendo.
          </p>
          <p className="leading-relaxed font-medium" data-id="element-189">
            Sientes esa impotencia amarga de no saber cómo ayudar a la persona
            que más amas en el mundo mientras el caos sube de tono.
          </p>
        </motion.div>
      </div>
    </section>;
}